import React from 'react';
import { S2Typography } from 'apps/sigma2-ui/src/components/ui/Typography';
import { Spacing } from 'apps/sigma2-ui/src/components/ui/Spacing';

interface TableGridColumnHeaderTooltipProps {
  metricDescription: string | undefined;
}

export const TableGridColumnHeaderTooltip: React.FC<
  TableGridColumnHeaderTooltipProps
> = ({ metricDescription }) => {
  return (
    <Spacing direction="vertical" size="md">
      {metricDescription && (
        <div className="border-l-4 border-teal-500">
          <S2Typography
            variant="body-7"
            textColorVariant="gray-900"
            translatedContent={metricDescription}
            dangerouslyOverrideClassNameFn={(cn) => `${cn} pl-3`}
          />
        </div>
      )}
    </Spacing>
  );
};
